import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.media',
        controls: '.video__controls',
        videoComponent: '.video',
        video: '.video__video',
        videoMobile: '.video__video-mobile',
        videoWrapper: '.video__wrapper',
        activateButtonWrapper: '.media__play-wrapper',
        backdrop: '.video-lighthouse',
        closeButton: '.video__close-button',
        playPauseBtn: '.video__play-pause',

    },
    classNames: {
        videoHide: 'video__video--hidden',
        videoWrapperSmall: 'video__wrapper--small',
        iconButtonWrapper: 'media__play-wrapper--hidden',
        videoFullscreen: 'video--fullscreen',
        videoControlsHidden: 'video__controls--hidden',
    },
    playIcon: '<span class="video__play-pause-icon icon-TickCirclePlay3"></span>',
    pauseIcon: '<span class="video__play-pause-icon icon-TickCirclePause3"></span>',
};

class Media {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
    }

    init() {
        this._elements = this._getDomElements();

        if(this._elements.$video.length === 0) {
            this._elements.$activateButtonWrapper.hide();
        }

        this._elements.$videoWrapper.addClass(config.classNames.videoWrapperSmall);
        this._elements.$video.addClass(config.classNames.videoHide);
        this._elements.$videoMobile.addClass(config.classNames.videoHide);
        this._fullSizedVideo();
        this._closeVideo();
    }

    _getDomElements() {
        return {
            $body: $('body'),
            $html: $('html'),
            $controls: this._$rootElement.find(config.selectors.controls),
            $video: this._$rootElement.find(config.selectors.video),
            $videoMobile: this._$rootElement.find(config.selectors.videoMobile),
            $videoComponent: this._$rootElement.find(config.selectors.videoComponent),
            $videoWrapper: this._$rootElement.find(config.selectors.videoWrapper),
            $activateButtonWrapper: this._$rootElement.find(config.selectors.activateButtonWrapper),
            $backdrop: this._$rootElement.find(config.selectors.backdrop),
            $closeButton: this._$rootElement.find(config.selectors.closeButton),
            $playPauseBtn: this._$rootElement.find(config.selectors.playPauseBtn),
        };
    }

    // eslint-disable-next-line class-methods-use-this
    _addEventListeners() {
    }

    _removeStandardControls() {
        const videoWorks = !!document.createElement('video').canPlayType;

        if (videoWorks) {
            this._elements.$video[0].controls = false;
            this._elements.$controls.removeClass('hidden');
        }
    }

    _fullSizedVideo() {
        this._elements.$activateButtonWrapper.on('click', () => {
            this._elements.$video.removeClass(config.classNames.videoHide);
            this._elements.$videoMobile.removeClass(config.classNames.videoHide);
            this._elements.$videoWrapper.removeClass(config.classNames.videoWrapperSmall);
            this._elements.$controls.removeClass(config.classNames.videoControlsHidden);
            this._elements.$backdrop[0].style.opacity = '1';
            this._elements.$backdrop[0].style.visibility = 'visible';
            this._elements.$video[0].style.opacity = '1';
            this._elements.$video[0].style.visibility = 'visible';
            this._elements.$html.addClass('body--no-scroll');
            // this._elements.$video.show();
            this._elements.$videoMobile.show();
            this._elements.$activateButtonWrapper.addClass(config.classNames.iconButtonWrapper);
            this._elements.$video[0].player.play();

            // html.style.overflow = "hidden"
            // main.style.overflow = "hidden"
            // body.style.overflow = "hidden"
        });
    }

    _closeVideo() {
        const videoSettings = this._elements.$video[0];
        // eslint-disable-next-line no-unused-vars
        this._elements.$closeButton.on('click', (e) => {
            // this._elements.$video.hide();
            this._elements.$videoMobile.hide();
            this._elements.$video.addClass(config.classNames.videoHide);
            this._elements.$videoMobile.addClass(config.classNames.videoHide);
            this._elements.$videoWrapper.addClass(config.classNames.videoWrapperSmall);
            this._elements.$controls.addClass(config.classNames.videoControlsHidden);
            this._elements.$videoComponent.removeClass(config.classNames.videoFullscreen);
            this._elements.$activateButtonWrapper.removeClass(config.classNames.iconButtonWrapper);
            this._elements.$backdrop[0].style.opacity = '0';
            this._elements.$backdrop[0].style.visibility = 'hidden';
            this._elements.$video[0].style.opacity = '0';
            this._elements.$video[0].style.visibility = 'hidden';
            this._elements.$html.removeClass('body--no-scroll');
            videoSettings.player.pause();
            this._elements.$playPauseBtn.html(config.playIcon);
        });
    }
}

moduleRegistry.registerModule('Media', Media);
moduleRegistry.autoApplyModule('Media', config.selectors.root);
